module.exports = __webpack_public_path__ + "media/images/sp/specials/fair_event/area_shibuya-9cbb6dbb1a5265f9e7e6f8518d07469c.jpg";